// 409 Conflict handling for the current-loan flow: every 409 opens a popup that shows the
// backend's own title/message when it sends one, else the LOAN_CONFLICT / AURA_IN_PROGRESS
// entries from public/error-messages.json.

// Backend error code for a write rejected because AURA is running (CX.AUS.RESULT "In Progress").
export const AURA_IN_PROGRESS_ERROR_CODE = "ERR-AURA-001";

const CONFLICT_STATUS = 409;

// RTK Query surfaces the status as `status` (or `originalStatus` when the body isn't JSON);
// some legacy loan endpoints echo it as `status_code` in the body.
export const isConflictError = (err) =>
	[err?.status, err?.originalStatus, err?.status_code, err?.data?.status_code].some(
		(value) => Number(value) === CONFLICT_STATUS
	);

export const isAuraInProgressError = (err) =>
	err?.data?.error?.code === AURA_IN_PROGRESS_ERROR_CODE;

// Optimal Blue's transient 409 while an earlier push is queued:
// { status: "Fail", data: { Message: "Push is in queue." } }. Not a loan conflict — it clears
// in about a minute, so callers retry or ask the broker to wait (OB_PUSH_IN_QUEUE).
export const isObPushInQueue = (err) =>
	isConflictError(err) &&
	/push is in queue/i.test(String(err?.data?.data?.Message || err?.data?.Message || ""));

// { title, message, code } for the conflict popup. `getErrorMessage` is useErrorMessages().getErrorMessage.
export const getConflictPopup = (err, getErrorMessage) => {
	const key = isAuraInProgressError(err) ? "AURA_IN_PROGRESS" : "LOAN_CONFLICT";
	const fallback = getErrorMessage ? getErrorMessage(key) : {};
	const body = err?.data?.error || {};
	return {
		title: body.title || fallback?.title || "Loan was changed",
		message: body.message || fallback?.message || "",
		code: body.code || fallback?.code || key,
	};
};
